import React from "react";
import Nav from "@/components/Nav";
import Hook from "@/components/Hook";
import Origin from "@/components/Origin";
import Hats from "@/components/Hats";
import Proof from "@/components/Proof";
import Testimonials from "@/components/Testimonials";
import Operate from "@/components/Operate";
import LabTeaser from "@/components/LabTeaser";
import Signal from "@/components/Signal";
import { useSEO } from "@/lib/useSEO";

export default function SamErpik() {
  useSEO({ canonical: "/" });

  return (
    <main className="relative w-full">
      <Nav />

      {/* Content sections scroll over the canvas */}
      <div className="relative z-10">
        <Hook />
        <Origin />
        <Hats />
        <Proof />
        <Testimonials />
        <Operate />
        <LabTeaser />
        <footer role="contentinfo">
          <Signal />
        </footer>
      </div>

      {/* Terminal is mounted globally in App.js — accessible on every route. */}
    </main>
  );
}
